<template>
    <!-- Form -->
     <div class="bg-light p-4 rounded shadow-sm">
    <form @submit.prevent="submitForm">
      <div v-show="currentStep === 1">

      <div class="mb-3">
          <div class="input-group">
            <span class="input-group-text">
              <i class="bi bi-person-badge-fill"></i>
            </span>
            <input
              v-model="form.first_name"
              type="text"
              class="form-control"
              placeholder="Enter student first name"
              required
            />
          </div>
        </div>

        <!-- Last Name -->
        <div class="mb-3">
          <div class="input-group">
            <span class="input-group-text">
              <i class="bi bi-person-badge"></i>
            </span>
            <input
              v-model="form.last_name"
              type="text"
              class="form-control"
              placeholder="Enter student last name"
              required
            />
          </div>
        </div>

        <!-- Age -->
        <div class="mb-3">
          <div class="input-group">
            <span class="input-group-text">
              <i class="bi bi-hourglass-split"></i>
            </span>
            <input
              v-model="form.age"
              type="number"
              class="form-control"
              placeholder="Enter student age"
              required
            />
          </div>
        </div>

        <!-- Birth Date -->
        <div class="mb-3">
          <div class="input-group">
            <span class="input-group-text">
              <i class="bi bi-calendar-event-fill"></i>
            </span>
            <input
              v-model="form.birth_day"
              type="date"
              class="form-control"
              required
            />
          </div>
        </div>

        <!-- Gender -->
        <div class="mb-3">
          <div class="input-group">
            <span class="input-group-text">
              <i class="bi bi-gender-ambiguous"></i>
            </span>
            <select v-model="form.gender" class="form-select" required>
              <option value="gender" disabled>Select Gender</option>
              <option value="male"><i class="bi bi-gender-male"></i> Male</option>
              <option value="female">Female</option>
              <option value="other">Other</option>
            </select>
          </div>
        </div>

        <!-- Contact -->
        <div class="mb-3">
          <div class="input-group">
            <span class="input-group-text">
              <i class="bi bi-telephone-fill"></i>
            </span>
            <input
              v-model="form.contact"
              type="text"
              class="form-control"
              placeholder="Enter student phone number"
              required
            />
          </div>
        </div>
        
        <!-- Success Message -->
         <div v-if="successMessage" class="alert alert-success">
          <i class="bi bi-check-circle-fill"></i> {{ successMessage }}
        </div>
        
        <!-- Error Message -->
         <div v-if="errorMessage" class="alert alert-danger">
          <i class="bi bi-exclamation-circle-fill"></i> {{ errorMessage }}
        </div>
        
        <div class="btnClassA">
          <button @click="nextStep" class="btn btn-primary fieldClass" type="button">
            <i class="bi bi-arrow-right-circle"></i> Next
          </button>
        </div>


      </div>

<div v-show="currentStep === 2">
  <h3><i class="bi bi-journal-text"></i> Item Details</h3>


  <!-- Institute -->
        <div class="mb-3">
          <div class="input-group">
            <span class="input-group-text">
              <i class="bi bi-building-fill"></i>
            </span>
            <select v-model="form.institute" class="form-select" id="institute" required @change="fetchTeachers">
              <option value="" disabled>Select Institute</option>
              <option v-for="institute in institutes" :key="institute.id" :value="institute.id">
                {{ institute.institute_name }}
              </option>
            </select>
          </div>
        </div>



        <!-- Teacher Dropdown -->
        <div class="mb-3">
          <div class="input-group" v-if="teachers.length > 0">
            <span class="input-group-text">
              <i class="bi bi-person-fill"></i>
            </span>
            <select v-model="form.teacher" id="teacher" class="form-control" required @change="fetchSubjects">
              <option value="" disabled>Select Teacher</option>
              <option v-for="teacher in teachers" :key="teacher.id" :value="teacher.id">
                {{ teacher.user.first_name }} {{ teacher.user.last_name }}
              </option>
            </select>
          </div>
        </div>

        <!-- Subject Dropdown (shown only after teacher selected and subjects fetched) -->
        <div class="mb-3">
          <div class="input-group" v-if="subjects.length > 0">
            <span class="input-group-text">
              <i class="bi bi-book-fill"></i>
            </span>
            <select v-model="form.subject" id="subject" class="form-control" required>
              <option disabled value="">Select Subject</option>
              <option v-for="subject in subjects" :key="subject.id" :value="subject.id">
                {{ subject.name }}
              </option>
            </select>
          </div>
        </div>

        <!-- Grade -->
        <div class="mb-3">
          <div class="input-group">
            <span class="input-group-text">
              <i class="bi bi-mortarboard-fill"></i>
            </span>
            <select v-model="form.grade" id="grade" class="form-control" required>
              <option disabled value="">Select Grade</option>
              <option v-for="grade in grades" :key="grade.id" :value="grade.id">
                Grade {{ grade.grade_level }}
              </option>
            </select>
          </div>
        </div>

        <!-- Registration Number -->
        <div class="mb-3">
          <div class="input-group">
            <span class="input-group-text">
              <i class="bi bi-hash"></i>
            </span>
            <input
              v-model="form.stu_reg_number"
              id="stuRegNumber"
              type="text"
              class="form-control"
              placeholder="Enter student registration number"
              required
            />
          </div>
        </div>

      <div class="btnClassA d-flex justify-content-between gap-2">
          <button @click="prevStep" class="btn btn-secondary fieldClass" type="button">
            <i class="bi bi-arrow-left-circle"></i> Prev
          </button>
          <button @click="nextStep" class="btn btn-primary fieldClass" type="button">
            <i class="bi bi-arrow-right-circle"></i> Next
          </button>
        </div>


      </div>

<div v-show="currentStep === 3">
  <h3><i class="bi bi-credit-card-fill"></i> Account Details</h3>

  <!-- Payment Type -->
  <div class="mb-3">
    <div class="input-group">
      <span class="input-group-text">
        <i class="bi bi-wallet2"></i>
      </span>
      <select v-model="form.payType" id="grade" class="form-control" required>
        <option value="" disabled>Select Payment Type</option>
        <option v-for="payType in payTypes" :key="payType.id" :value="payType.id">
          {{ payType.payment_type }}
        </option>
      </select>
    </div>
  </div>

  <!-- Amount -->
  <div class="mb-3">
    <div class="input-group">
      <span class="input-group-text">
        <i class="bi bi-cash-stack"></i>
      </span>
      <input v-model="form.amount" id="amount" placeholder="Enter amount" class="form-control" required/>
    </div>
  </div>

   <!-- Payment Date -->
  <div class="mb-3">
    <div class="input-group">
      <span class="input-group-text">
        <i class="bi bi-calendar-check-fill"></i>
      </span>
      <input type="datetime-local" v-model="form.payment_date" id="payment_date" class="form-control" required/>
    </div>
  </div>

  <!-- Expire Date -->
  <div class="mb-3">
    <div class="input-group">
      <span class="input-group-text">
        <i class="bi bi-calendar-x-fill"></i>
      </span>
      <input type="datetime-local" v-model="form.exp_date" id="exp_date" class="form-control" readonly/>
    </div>
  </div>


      <!-- Success Message -->
      <div v-if="successMessage" class="alert alert-success">
        <i class="bi bi-check-circle-fill"></i> {{ successMessage }}
      </div>

      <!-- Error Message -->
      <div v-if="errorMessage" class="alert alert-danger">
        <i class="bi bi-exclamation-circle-fill"></i> {{ errorMessage }}
      </div>




      <!-- Buttons -->
  <div class="btnClassA">
    <button type="button" @click="prevStep" class="btn btn-secondary fieldClass">
      <i class="bi bi-arrow-left-circle"></i> Prev
    </button>
    <button type="submit" class="btn btn-primary w-100 mt-4" :disabled="loading">
      <i v-if="loading" class="spinner-border spinner-border-sm"></i>
      <span v-if="loading">Submitting...</span>
      <span v-else><i class="bi bi-send-fill"></i>Submit</span>
    </button>
  </div>

      </div>
    </form>
    </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      currentStep: 1,
      form: {
        first_name: '',
        last_name: '',
        age: '',
        birth_day: '',
        gender: 'gender', // Added gender field
        contact: '',
        address: '',
        grade: '',
        subject: '',
        stu_reg_number:'',
        teacher: '',
        institute: '',
        payType:'',
        amount:'',
        // payment_date: this.getTodayDate(),
        payment_date: this.getTodayDateTime(),
        exp_date: '',
      },
      grades: [],
      subjects: [],
      teachers: [],
      institutes: [],
      payTypes: [],
      successMessage: '',
      errorMessage: '',
      loading: false  // <-- Add this
    };
  },
  watch: {
  'form.payType'() {
    if (this.form.payment_date) {
      this.calculateExpDate(); // Recalculate expiration date if payment type is changed
    }
  },
  'form.payment_date'() {
    if (this.form.payType) {
      this.calculateExpDate(); // Recalculate expiration date if payment date is changed
    }
  },
},

  methods: {
    nextStep() {
      if (this.currentStep < 3) {
        this.currentStep++;
      }
    },

    prevStep() {
      if (this.currentStep > 1) {
        this.currentStep--;
      }
    },
    // getTodayDate() {
    //   const today = new Date();
    //   return today.toISOString().split("T")[0]; // Formats date as YYYY-MM-DD
    // },
    getTodayDateTime() {
    const today = new Date();
    return this.formatDateTime(today); // Format the current date and time with seconds
  },

  calculateExpDate() {
    const paymentDate = new Date(this.form.payment_date); // Get the payment date
    switch (parseInt(this.form.payType)) {
      case 1: // Hourly: Add 1 hour to payment date
        paymentDate.setHours(paymentDate.getHours() + 1);
        break;
      case 2: // Daily: Add 1 day to payment date
        paymentDate.setDate(paymentDate.getDate() + 1);
        break;
      case 3: // 1 Weekly: Add 7 days to payment date
        paymentDate.setDate(paymentDate.getDate() + 7);
        break;
      case 4: // 2 Weekly: Add 14 days to payment date
        paymentDate.setDate(paymentDate.getDate() + 14);
        break;
      case 5: // 3 Weekly: Add 21 days to payment date
        paymentDate.setDate(paymentDate.getDate() + 21);
        break;
      case 6: // Monthly: Add 1 month to payment date
        paymentDate.setMonth(paymentDate.getMonth() + 1);
        break;
      default:
        break;
    }

    // After modification, format the expiration date
    this.form.exp_date = this.formatDateTime(paymentDate);
  },

  formatDateTime(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  // Return in the format required by <input type="datetime-local">
  return `${year}-${month}-${day}T${hours}:${minutes}`;
},
    async submitForm() {
      // Set loading to true before starting the request
      this.loading = true;

      const formData = new FormData();
      formData.append('first_name', this.form.first_name);
      formData.append('last_name', this.form.last_name);
      formData.append('age', this.form.age);
      formData.append('birth_day', this.form.birth_day);
      formData.append('gender', this.form.gender);
      formData.append('contact', this.form.contact);
      formData.append('grade', this.form.grade);
      formData.append('subject', this.form.subject);
      formData.append('stu_reg_number', this.form.stu_reg_number);
      formData.append('teacher', this.form.teacher);
      formData.append('institute', this.form.institute);
      formData.append('payment_type', this.form.payType);
      formData.append('amount', this.form.amount);
      formData.append('payment_date', this.form.payment_date);
      formData.append('exp_date', this.form.exp_date);

      try {
        const response = await axios.post('/student-register', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        this.successMessage = response.data.success;
    this.errorMessage = '';

    // ✅ Reset form fields
    this.form = {
      first_name: '',
      last_name: '',
      age: '',
      birth_day: '',
      gender: '',
      contact: '',
      grade: 'gender',
      subject: '',
      stu_reg_number: '',
      teacher: '',
      institute: '',
      payType: '',
      amount: '',
      payment_date: '',
      exp_date: '',
    };

    // ✅ Go back to first step
    this.currentStep = 1; // assuming you have currentStep controlling steps

      } catch (error) {
        if (error.response && error.response.data.errors) {
          // Aggregate all errors into one string
          const allErrors = Object.values(error.response.data.errors).flat();
          this.errorMessage = allErrors.join(' '); // Join all error messages
          } else if (error.response && error.response.data.error) {
            // General error message from backend
            this.errorMessage = error.response.data.error;
          } else {
            this.errorMessage = 'An unexpected error occurred.'; // General fallback error
            }
            this.successMessage = ''; // Clear success message
            }
            finally {
          // Set loading to false after the request is completed
          this.loading = false;
        }

        console.log('Form submitted!');
        // Emit the event to notify the parent component
        this.$emit('studentAdded');
      },
    async fetchGrades() {
      try {
        const response = await axios.get('/get-all-grades');
        this.grades = response.data;
      } catch (error) {
        this.errorMessage = 'Error fetching grades.';
      }
    },
    async fetchInstitutes() {
      try {
        const response = await axios.get('/get-all-institutes');
        this.institutes = response.data;
      } catch (error) {
        this.errorMessage = 'Error fetching institutes.';
      }
    },

    fetchTeachers() {
    if (!this.form.institute) return;
    axios.get('/admin-get-teachers-by-institute', {
      params: { institute_id: this.form.institute }
    })
    .then(response => {
      this.teachers = response.data;
      this.form.teacher = '';
      this.subjects = [];
      this.form.subject = '';
    })
    .catch(error => console.error('Error fetching teachers:', error));
  },

  fetchSubjects() {
    if (!this.form.teacher) return;
    axios.get('/admin-get-subjects-by-teacher', {
      params: { teacher_id: this.form.teacher }
    })
    .then(response => {
      this.subjects = response.data;
      this.form.subject = '';
    })
    .catch(error => console.error('Error fetching subjects:', error));
  },
    async fetchPayTypes() {
      try {
        const response = await axios.get('/get-all-payTypes');
        this.payTypes = response.data;
      } catch (error) {
        this.errorMessage = 'Error fetching Payement types.';
      }
    },
  },
  created() {
    this.form.payment_date = this.getTodayDateTime();
    this.fetchGrades();
    this.fetchSubjects();
    this.fetchTeachers();
    this.fetchInstitutes();
    this.fetchPayTypes();
  },
};
</script>

<style scoped>
.alert {
  margin-bottom: 20px;
}
.form-container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.text-start {
  text-align: left;
}
.form-group label i {
  margin-right: 5px;
}
</style>
